/**
    * @description      : 
    * @author           : Saif
    * @group            : 
    * @created          : 04/11/2024 - 23:01:24
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 04/11/2024
    * - Author          : Saif
    * - Modification    : 
**/
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import BackButton from "../../Components/BackButton";
import CustomModal from "../../Components/CustomModal";
import CustomButton from "../../Components/CustomButton";
import { useGet, usePatch, usePost } from "../../Api";
import { male1 } from "../../Assets/images";
import FormatDateTime from "../../Components/DateFormate";

const formatStatus = (value) => {
  if (!value) return '';
  return String(value).replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
};

export const ReservationDetail = () => {

    const { id } = useParams();
    const [data, setData] = useState({});
    const [userStatus, setUserStatus] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [showModal4, setShowModal4] = useState(false);
    const [historyData, setHistoryData] = useState();
    const [message, setMessage] = useState(false)
    const { ApiData: UseeListingData, loading: UseeListingLoading, error: UseeListingError, get: GetUseeListing } = useGet(`/reservations-details/${id}`);
    const { ApiData: StatusUpdateData, loading: StatusUpdateLoading, error: StatusUpdateError, post: GetStatusUpdate } = usePost(`/users/${id}/approve`);



    const inActive = () => {
        setShowModal(false)
        setUserStatus({
            ...userStatus,
            status: 0
        })
        setShowModal2(true)

        setTimeout(() => {
            setShowModal2(false)
        }, 1000)
        console.log('status', userStatus)
    }
    const Active = () => {
        setShowModal3(false)
        setUserStatus({
            ...userStatus,
            status: 1
        })
        setShowModal4(true)
        setTimeout(() => {
            setShowModal4(false)
        }, 1000)
        console.log('status', userStatus)
    }

    useEffect(() => {
        if (userStatus.status) {
            GetStatusUpdate(userStatus);
        }
    }, [userStatus])


    useEffect(() => {
        if (StatusUpdateData) {
            GetUseeListing()
        }
    }, [StatusUpdateData])

    useEffect(() => {
        GetUseeListing()
    }, [])


    useEffect(() => {
        if (UseeListingData) {
            setData(UseeListingData?.original)
        }
    }, [UseeListingData])




    return (
        <>
            <DashboardLayout>
                <div className="dashCard mb-4">
                    <div className="row mb-3">
                        <div className="col-12 mb-2">
                            <h2 className="mainTitle">
                                <BackButton />
                                Reservation Details
                            </h2>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="row mb-3 justify-content-end">
                                <div className="col-lg-4 text-end order-1 order-lg-2 mb-3">

                                    <span className={`statusBadge ${data?.status === 'confirmed' ? 'statusBadgeActive' : 'statusBadgeInactive'}`}>{formatStatus(data?.status)}</span>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Reservation ID</h4>
                                    <p className="secondaryText">{data?.id}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">User ID</h4>
                                    <p className="secondaryText">{data?.user_id}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">List ID</h4>
                                    <p className="secondaryText">{data?.list_id}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Status</h4>
                                    <p className="secondaryText text-capitalize">{formatStatus(data?.status)}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Confirmation Status</h4>
                                    <p className="secondaryText">{data?.confirmation_status === 1 ? 'Confirmed' : 'Not Confirmed'}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Payment Status</h4>
                                    <p className="secondaryText">{data?.payment_status === 'paid' ? 'Paid' : 'Unpaid'}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Payment Method</h4>
                                    <p className="secondaryText">{data?.payment_method || 'N/A'}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Billing For</h4>
                                    <p className="secondaryText">{data?.billing_for}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Guests</h4>
                                    <p className="secondaryText">{data?.guests}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Subtotal</h4>
                                    <p className="secondaryText">${data?.subtotal}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Check-In Date</h4>
                                    <p className="secondaryText">{data?.check_in}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Check-Out Date</h4>
                                    <p className="secondaryText">{data?.check_out}</p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Created At</h4>
                                    <p className="secondaryText"><FormatDateTime isoDateString={data?.created_at}/></p>
                                </div>

                                <div className="col-xl-4 col-md-4 mb-3">
                                    <h4 className="secondaryLabel">Address</h4>
                                    <p className="secondaryText">{data?.address}</p>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>

                <CustomModal show={showModal} close={() => { setShowModal(false) }} action={inActive} heading='Are you sure you want to mark this user as inactive?' />
                <CustomModal show={showModal2} success heading='Marked as Inactive' />

                <CustomModal show={showModal3} close={() => { setShowModal3(false) }} action={Active} heading='Are you sure you want to mark this user as Active?' />
                <CustomModal show={showModal4} success heading='Marked as Active' />
            </DashboardLayout>
        </>
    );
};

